import { User } from "oidc-client-ts";

// Decouples the API auth middleware from react-oidc-context: AuthGuard registers a getter for the
// current user here, and getAccessToken() reads the token from it. The accessor (or the whole
// accessor) may be null when no user is signed in / on cleanup.
let getUser: (() => User | null | undefined) | null = null;

export function setTokenAccessor(accessor: (() => User | null | undefined) | null): void {
  getUser = accessor;
}

export function getAccessToken(): string | undefined {
  return getUser?.()?.access_token;
}
